import React from "react";

function ExportCsvButton({ results }) {
  const exportToCsv = () => {
    // Prepare CSV header
    const header = ["Email", "Is Valid", "Risk Level", "Confidence Score"];

    // Map results to CSV rows
    const rows = results.map((r) => [
      r.email,
      r.is_valid ? "Valid" : "Invalid",
      r.risk_level,
      `${Math.round(r.confidence_score * 100)}%`,
    ]);

    // Combine header and rows
    const csvContent =
      [header, ...rows]
        .map((e) => e.join(","))
        .join("\n");

    // Create blob and download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "email_validation_results.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={exportToCsv}
      className="text-sm text-blue-600 hover:underline"
      type="button"
    >
      Export CSV
    </button>
  );
}

export default ExportCsvButton;